export default {
  errors: {
    not_found: () => "デバイスを再接続してリロードしてください。",
    permission_denied: () =>
      "カメラ、マイクの利用を許可してください。<span class='highlight'>許可いただけない場合はビデオ会議システムに参加することができません。</span>ブラウザ設定にてカメラ、マイクの利用を許可し、画面をリロードしてください。<br><span class='highlight'>メッセージアプリの内部ブラウザなどで閲覧している場合はカメラ、マイクが利用できません。</span>対応ブラウザに切り替えてご利用ください。",
    no_mic: () =>
      "マイクが見つかりません。<span class='highlight'>マイクが接続されていない場合、ビデオ会議システムに参加することができません。</span>お使いにデバイスにマイクが接続されているか、また別のアプリケーションで使われていないかをご確認のうえ画面をリロードしてください。",
    general: () =>
      "カメラ、マイクのハードウェアが見つかりません。<span class='highlight'>別のアプリケーションで使われているか認識されていない可能性があります。</span><br />カメラやマイク機能を使っていた別のアプリケーションを終了させた場合は、画面をリロードしていただき「画面右下の︙のアイコン」を押してデバイスを選んで下さい。",
    general_entry: () =>
      "カメラ、マイクのハードウェアが見つかりません。<span class='highlight'>別のアプリケーションで使われているか認識されていない可能性があります。</span><br />部屋に入ることはできますが、カメラがないと相手には映像は送れず、マイクがないと音声をおくることはできません。ご了承ください。"
  },
  alert: {
    audio_only: () =>
      "<span class='highlight'>カメラのハードウェアが見つからないため、現在音声のみで通話しています。</span>カメラを利用する場合は、カメラを接続したうえで使用するカメラを選択し、画面をリロードしてください。",
    muted: name => `${name}さんによってミュートされました。`,
    muted_by_undefined: () => "ほかの参加者によってミュートされました。",
    camera_found: () => "カメラが接続されました。利用するにはリロードしてください。"
  }
}
